import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { Screens } from "@/components/landing/Screens";
import { Download } from "@/components/landing/Download";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[var(--cream)]">
      <Nav />
      <main>
        <Hero />
        <Features />
        <Screens />
        <Download />
      </main>
      <Footer />
    </div>
  );
}
